import { Component } from '@angular/core';


@Component({
  selector: 'app-unauthorised-error',
  templateUrl: './unauthorised-error.component.html',
  styleUrls: ['./unauthorised-error.component.css']
})
export class UnauthorisedErrorComponent {
}
